import * as Sentry from '@sentry/vue'
import { captureConsoleIntegration } from '@sentry/browser'

const Boot = ({ app }) => {
  if (import.meta.env.PROD) {
    Sentry.init({
      app,
      dsn: 'https://aad01c6427f5cf3a72e0c1164045de8a@o273464.ingest.us.sentry.io/4509452217942016',
      environment: import.meta.env.MODE,
      sendDefaultPii: true,
      integrations: [captureConsoleIntegration({ levels: ['error'] })],
    })
  }
}

export default Boot
